/**
 * Not a Pitch tags (mobile app, Tagging V2) carry no pitch result: their
 * metadata is `event_type: "not_of_interest"`. Omnibus has no NotAPitch pitch
 * result, so the table shows them as a "NotAPitch" pick of its own.
 */
export const NOT_A_PITCH = "NotAPitch";
const NOT_OF_INTEREST = "not_of_interest";

type TagMetadata = Record<string, unknown>;

/** The pitch result a row shows for a tag's metadata. */
export const getRowPitchResult = (metadata: TagMetadata | undefined) =>
  metadata?.event_type === NOT_OF_INTEREST
    ? NOT_A_PITCH
    : (metadata?.pitchResult as string | undefined) || "Unknown";

/**
 * Writes a row's pitch and play result into a tag's metadata (in place).
 * Not a Pitch is sent as the event type with neither result: a play result
 * would end the at bat in the game service. Any other pick drops the event
 * type, which the game service reads before the pitch result.
 */
export const applyRowResults = (
  metadata: TagMetadata,
  pitchResult: string | undefined,
  playResult: string | undefined,
) => {
  if (pitchResult === NOT_A_PITCH) {
    metadata.event_type = NOT_OF_INTEREST;
    delete metadata.pitchResult;
    delete metadata.playResult;
    return;
  }

  if (pitchResult && metadata.event_type === NOT_OF_INTEREST) {
    delete metadata.event_type;
  }
  if (pitchResult) {
    // Clear pitchResult if user selected "Unknown"
    metadata.pitchResult = pitchResult === "Unknown" ? null : pitchResult;
  }
  if (playResult) {
    // Clear playResult if user selected "Unknown"
    metadata.playResult = playResult === "Unknown" ? null : playResult;
  }
};
